const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  quantityUpdate: 'quantity-update',
  optionValueSelectionChange: 'option-value-selection-change',
  variantChange: 'variant-change',
  cartError: 'cart-error',
};

// const ADAS = {
//   tier2VariantId: 45878052421787,
//   tier3RegularVariantId: 45878052454555,
//   tier3UpgradeVariantId: 46011164426395,
//   tier3RegularLabelId: 4154985283739,
//   tier3UpgradeLabelId: 4287251021979,
// }

const ADAS = {
  tier2VariantId: 50083863363880,
  tier3RegularVariantId: 50083863396648,
  tier3UpgradeVariantId: 50083863429416,
  tier3RegularLabelId: 4621198852392,
  tier3UpgradeLabelId: 4621198885160,
}
